import React from 'react';

import { bemBlock } from '../../modules/bem';

import './DropdownScrollArea.less';

const block = bemBlock('dropdown-scroll-area');

type DropdownScrollAreaProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  'data-role'?: string;
  className?: string;
};

/** @deprecated use ActionsMenu from @neptune/shared/venus-ui instead */
export function DropdownScrollArea({
  children,
  className,
  'data-role': dataRole,
  ...props
}: DropdownScrollAreaProps) {
  return (
    <div {...props} className={block({ extra: className })} data-role={dataRole}>
      <div className={block('inner')}>{children}</div>
    </div>
  );
}
